export default {
    state: {
        archivos:[],
        loading: false,
    },
    getters: {
        loading: state => state.loading,
        archivos: state=> state.archivos
    },
    mutations: {
        setLoading: (state, payload) => state.loading = payload,
        setArchivos:(state, payload) => state.archivos = payload
    },
    actions: {
        exportar({
            commit,
            dispatch
        }, payload) {
            return new Promise((res, rej) => {
                this.getters.api.post('/exportar/venta_cartera', payload)
                    .then(response => {
                        res(response)
                    }).catch(error =>
                        rej(error)
                    )
            })
        },
        listar({
            commit,
            dispatch
        }, payload) {
            commit('setLoading', true);
            return new Promise((res, rej) => {
                this.getters.api.get('/informes/informe-venta-cartera', payload)
                    .then(response => {
                        res(response)
                    }).catch(error =>
                        rej(error)
                    )
            }).then((data) => {
                commit('setArchivos', data.data);
            }).catch((err) => {
                console.log(err);
            }).then(()=> {
                commit('setLoading', false);
            })
        },
        download({
            commit,
            dispatch
        }, payload) {
            return new Promise((res, rej) => {
                this.getters.api.post('/exportar/venta_cartera/descargar', payload)
                    .then(response => {
                        res(response)
                    }).catch(error =>
                        rej(error)
                    )
            })
        },
        eliminar({
            commit,
            dispatch
        }, payload){
            return new Promise((res, rej) => {
                this.getters.api.delete('/exportar/venta_cartera/eliminar',{ params: payload})
                    .then(response => {
                        res(response)
                    }).catch(error =>
                        rej(error)
                    )
            })
        }
    }
}